import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, Lock, LogIn } from "lucide-react";
import AuthLayout from "../components/AuthLayout";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      nav("/");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h2 className="text-2xl font-extrabold mb-1" data-testid="login-title">Welcome back</h2>
      <p className="text-rv-sub text-sm mb-7">Sign in to keep listening to your stations.</p>

      {err && (
        <div className="mb-4 text-sm text-rv-red bg-rv-red/10 border border-rv-red/30 rounded-xl px-4 py-3" data-testid="login-error">
          {err}
        </div>
      )}

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs font-semibold text-rv-sub mb-1.5 block">Email</label>
          <div className="relative">
            <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-rv-muted" />
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="field pl-10" data-testid="login-email-input" />
          </div>
        </div>
        <div>
          <div className="flex justify-between items-center mb-1.5">
            <label className="text-xs font-semibold text-rv-sub">Password</label>
            <Link to="/forgot-password" className="text-xs text-rv-cyan hover:underline" data-testid="forgot-link">Forgot password?</Link>
          </div>
          <div className="relative">
            <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-rv-muted" />
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="field pl-10" data-testid="login-password-input" />
          </div>
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2" data-testid="login-submit-button">
          {loading ? <span className="spinner" /> : <LogIn size={18} />}
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>

      <p className="text-center text-sm text-rv-sub mt-6">
        Have an access code?{" "}
        <Link to="/register" className="text-rv-cyan font-semibold hover:underline" data-testid="goto-register">Redeem it</Link>
      </p>
      <p className="text-center text-xs text-rv-muted mt-4">
        <Link to="/admin/login" className="hover:text-rv-sub" data-testid="goto-admin">Admin access</Link>
      </p>
    </AuthLayout>
  );
}
